const sortParentsAndChildren = (arr) => {
  const map = new Map(arr.map((n) => [n.parent, n]));
  const sorted = [];
  for (let item = map.get(null); item; item = map.get(item.id)) {
    sorted.push(item);
  }
  return sorted;
};

export default sortParentsAndChildren;
